import React from 'react';
import { Icon } from 'react-icons-kit';

function SavingsResultCard({ icon, value, label, subtext }) {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 text-center">
      <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-secondary/20 mb-4">
        <Icon icon={icon} size={24} className="text-secondary" />
      </div>
      <p className="text-4xl font-bold text-secondary mb-2">{value}</p>
      <p className="text-gray-800 font-medium mb-2">{label}</p>
      <p className="text-sm text-gray-500">{subtext}</p>
    </div>
  );
}

export default SavingsResultCard;
